import { FC } from 'react';
import { useNotificationStore } from '@/store/useNotificationStore';
import { Toast } from './Toast';

export const ToastContainer: FC = () => {
  const { notifications, removeNotification } = useNotificationStore();

  return (
    <div className="fixed top-4 right-4 z-50">
      {notifications.map((notification) => (
        <Toast
          key={notification.id}
          notification={notification}
          onClose={removeNotification}
        />
      ))}
    </div>
  );
};
